module.exports = __webpack_public_path__ + "img/about_07.51b16a04.png";